import { render } from "./ObservationEntryDetailed.vue?vue&type=template&id=9bd2dbf6&scoped=true"
import script from "./ObservationEntryDetailed.vue?vue&type=script&lang=js"
export * from "./ObservationEntryDetailed.vue?vue&type=script&lang=js"

import "./ObservationEntryDetailed.vue?vue&type=style&index=0&id=9bd2dbf6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd2dbf6"]])

export default __exports__